import {LIVRAISON_ROUTES as livraisonRoutes} from "~/api/routes";

export const state = () => ({
  modes: []
});
export const getters = {
  modes: state => state.modes,
};
export const mutations = {
  LIST_MODES(state, modes){
    state.modes = modes;
  },
  CREATE_MODE(state, mode){
    state.modes.unshift(mode);
  },
  UPDATE_MODE(state, mode){
    state.modes = state.modes.map(m =>{
      if (m.livraison_mode_id === mode.livraison_mode_id)
        return mode;
      return m;
    });
  },
  DELETE_MODE(state, id){
    state.modes = state.modes.filter(m => m.livraison_mode_id !== id);
  },
};
export const actions = {
  async list({commit}) {
    return new Promise((resolve, reject) => {
       this.$api.request(livraisonRoutes.list)
        .then(res => {
          commit('LIST_MODES', res.payload);
          resolve();
        })
        .catch(error => {
          reject();
        });
    });
  },
  async create({commit}, params) {
    return new Promise((resolve, reject) => {
      this.$api.request(livraisonRoutes.create, {}, params)
        .then(res => {
          commit('CREATE_MODE', res.payload);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  async update({commit}, params) {
    return new Promise((resolve, reject) => {
      this.$api.request(livraisonRoutes.update, {id: params.id}, params.data)
        .then(res => {
          commit('UPDATE_MODE', res.payload);
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  async delete({commit}, params) {
    return new Promise((resolve, reject) => {
      this.$api.request(livraisonRoutes.delete, {id: params.id})
        .then(res => {
          commit('DELETE_MODE', params.id);
          resolve();
        })
        .catch(error => {
          reject();
        });
    });
  }
};
